import RoundedButton from 'components/RoundedButton';

export const LoginSection = () => {
  return (
    <div className="loginSection paddedMaxWidthContainer">
      <p
        style={{
          marginBottom: '1.5em',
          textAlign: 'center',
          fontWeight: 600,
          maxWidth: 600,
        }}
      >
        Sign in to see if any of your entries won!
      </p>

      <RoundedButton href={`/login?redirect=${encodeURIComponent('results')}`}>
        SIGN IN
      </RoundedButton>

      <style jsx>
        {`
          .loginSection {
            margin-bottom: 3em;
          }

          @media (min-width: 900px) {
            .loginSection {
              margin-bottom: 0;
            }
          }
        `}
      </style>
    </div>
  );
};
